/**
 * Le nombre de fois qu'il faut appliquer la décôte de 25% sur le montant de base de l'AVVC en fonction des revenus.
 */
enum MontantBaseAvvc {
	'smic1' = 0,
	'smic2' = 1,
	'smic3' = 2,
	'smic4' = 3,
	'smic5' = 3,
	'smic6' = 3,
	'smic7' = 3
}

/**
 * Le pourçentage du montant de base de l'AVVC qu'il faut ajouter au montant de l'aide en fonction du nombre d'enfants.
 */
enum PlusValueEnfantsAvvc {
	'aucunEnfant' = 0,
	'1Enfant' = 0.5,
	'2Enfants' = 0.8,
	'3Enfants' = 1.2
}

enum NatureAide {
	'aide' = 'd\'une <span class="font-semiBold">aide non remboursable</span>',
	'pret' = 'd\'un <span class="font-semiBold">prêt sans intérêt</span>'
}

const MONTANT_BASE_AVVC = 646.70;
const DECOTE_SUR_MONTANT_BASE_AVVC = 0.20;
const PLUS_VALUE_ENFANT_SUPP = 0.40;

export class CalculMontantAvvcService {

	private constructor(

	) { }

	public static calculerMontantAvvc(champEnfants: string, champMontant: string, nbEnfants: number): number {

		let tauxPlusValue;
		if (nbEnfants !== undefined) {
			if (nbEnfants > 3) {
				// Si plus de 3 enfants, il y a une plus-value de 40% par enfant au-delà du troisième
				tauxPlusValue = PlusValueEnfantsAvvc['3Enfants'] + ((nbEnfants - 3) * PLUS_VALUE_ENFANT_SUPP);
			} else {
				// Sinon, on applique la plus-value définie précédemment
				switch (+nbEnfants) {
				case 0:
					tauxPlusValue = PlusValueEnfantsAvvc.aucunEnfant;
					break;
				case 1:
					tauxPlusValue = PlusValueEnfantsAvvc['1Enfant'];
					break;
				case 2:
					tauxPlusValue = PlusValueEnfantsAvvc['2Enfants'];
					break;
				case 3:
					tauxPlusValue = PlusValueEnfantsAvvc['3Enfants'];
					break;
				default:
					tauxPlusValue = PlusValueEnfantsAvvc.aucunEnfant;
					break;
				}
			}
		} else {
			tauxPlusValue = PlusValueEnfantsAvvc[champEnfants];
		}

		// Le montant est bonifié de la plus-value correspondante au nombre d'enfants
		let montant = MONTANT_BASE_AVVC * (1 + tauxPlusValue);
		// On applique une décôte au montant en fonction des ressources déclarées
		montant -= montant * DECOTE_SUR_MONTANT_BASE_AVVC * MontantBaseAvvc[champMontant];

		return montant;
	}

	/**
	 * Détermine si l'aide prendra la forme d'une aide non remboursable ou d'un prêt sans intérêt
	 * et retourne la chaîne de caractères à afficher.
	 *
	 * @param champEnfants Le nombre d'enfants à charge de la personne demandant l'aide, utilisé si nbEnfants n'est pas
	 * renseigné (valeur maximum de 3 pour ce champ).
	 * @param champMontant Les revenus de la personne demandant l'aide.
	 * @param nbEnfants Le nombre d'enfants à charge de la personne demandant l'aide.
	 * @returns
	 */
	public static determinerNatureAideString(champEnfants: string, champMontant: string, nbEnfants: number): string {
		let lNbEnfants = nbEnfants;
		if (nbEnfants === undefined) {
			lNbEnfants = CalculMontantAvvcService._convertChampEnfantsToNumber(champEnfants);
		}

		let res: string;
		switch (champMontant) {
		case 'smic1':
		case 'smic2':
		case 'smic3':
			res = NatureAide.aide;
			break;
		case 'smic4':
			res = lNbEnfants >= 1 ? NatureAide.aide : NatureAide.pret;
			break;
		case 'smic5':
			res = lNbEnfants >= 2 ? NatureAide.aide : NatureAide.pret;
			break;
		case 'smic6':
			res = lNbEnfants >= 3 ? NatureAide.aide : NatureAide.pret;
			break;
		case 'smic7':
			res = NatureAide.pret;
			break;
		}
		return res;
	}

	private static _convertChampEnfantsToNumber(champEnfants: string) {
		let lNbEnfants: number;
		switch (champEnfants) {
		case 'aucunEnfant':
			lNbEnfants = 0;
			break;
		case '1Enfant':
			lNbEnfants = 1;
			break;
		case '2Enfants':
			lNbEnfants = 2;
			break;
		case '3Enfants':
			lNbEnfants = 3;
			break;
		}
		return lNbEnfants;
	}
}
